import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// P-AUTH-HOTFIX-2B: recovers the one case AuthContext's own session
// restoration cannot finish by itself. A Google sign-in that falls back to
// a full-page redirect (see signInWithOAuth in config/supabase.js) reloads
// the app fresh on /login or /register once Google sends the browser back —
// AuthContext's mount-time getSession()/getRedirectResult() recovery already
// restores `currentUser` correctly on that reload, but nothing was ever
// navigating the person away from the login/register screen they were
// visually still looking at.
//
// `suppress` is an escape hatch for a state the calling screen is already
// showing that must be allowed to finish/be seen on its own terms — Login's
// magic-link completion view, or Register's own "Bienvenue sur NSARA"
// success step after an in-page (non-reloaded) sign-in. Passing the right
// `suppress` from each caller is what keeps this from stealing those: on a
// real page reload nothing has set it, so the redirect proceeds; on an
// in-page success the caller's own state update lands in the same React
// commit as `currentUser` becoming truthy, so `suppress` is already true by
// the time this effect re-runs.
//
// P-AUTH-EMAIL-VERIFY-2: an authenticated-but-unverified person must never
// be bounced to /dashboard from here — that would let them bypass the
// EmailVerificationPending gate that ProtectedRoute would otherwise show
// them (see App.js). Requiring emailVerified === true is the exact same
// Firebase-native signal ProtectedRoute and BusinessContext use, so Google
// and completed Magic Link sign-ins (always verified) are unaffected.
export const useRedirectIfAuthenticated = (suppress = false) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || suppress || !currentUser || !currentUser.emailVerified) return;
    navigate('/dashboard');
  }, [loading, suppress, currentUser, navigate]);
};
